<template>
  <div class="w-full text-left p-12 flex flex-col justify-center items-center bg-[#F7F7F7]">
    <div class="text-center mb-8">
      <h2 class="text-4xl font-semibold text-[#3C3C3C]">Contact Us</h2>
      <div class="w-16 h-[3px] bg-[#E67E22] mx-auto mt-3"></div>
    </div>

    <form @submit.prevent="sendEmail" class="w-full max-w-lg bg-white shadow-lg rounded-lg p-8 space-y-6">
      <div>
        <label for="name" class="block text-sm font-medium text-[#3C3C3C]">Full Name</label>
        <input type="text" id="name" v-model="formData.name" class="w-full p-3 border rounded-lg bg-[#F7F7F7] text-[#3C3C3C]" required>
      </div>

      <div>
        <label for="email" class="block text-sm font-medium text-[#3C3C3C]">Contact Email</label>
        <input type="email" id="email" v-model="formData.email" class="w-full p-3 border rounded-lg bg-[#F7F7F7] text-[#3C3C3C]" required>
      </div>

      <div>
        <label for="message" class="block text-sm font-medium text-[#3C3C3C]">Your Message</label>
        <textarea id="message" v-model="formData.message" rows="5" class="w-full p-3 border rounded-lg bg-[#F7F7F7] text-[#3C3C3C]" required></textarea>
      </div>

      <button type="submit" class="w-full p-3 text-white bg-[#E67E22] rounded-lg hover:bg-orange-600 transition">
        Send Message
      </button>

      <p v-if="statusMessage" class="text-center text-sm text-green-600 mt-4">{{ statusMessage }}</p>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      formData: {
        name: "",
        email: "",
        message: ""
      },
      statusMessage: ""
    };
  },
  methods: {
    async sendEmail() {
      try {
        const params = new URLSearchParams();
        params.append("name", this.formData.name);
        params.append("email", this.formData.email);
        params.append("message", this.formData.message);

        const response = await axios.post(
            "https://script.google.com/macros/s/AKfycbzdLUPQQMSd5CW18DpH1ScYLhjlr72RZM-vyIaZguwPTrTBEzGo1w9yaZUWeHLtruJM_A/exec",
            params,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }
        );

        this.statusMessage = response.data.status === "OK"
            ? "Message sent successfully!"
            : "There was an error sending the message.";

        this.formData = { name: "", email: "", message: "" };
      } catch (error) {
        console.error("Error:", error);
        this.statusMessage = "Unable to connect to the server.";
      }
    }
  }
};
</script>
